<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="HomeInlet" toName="编辑内容" goPathName="首页快捷入口"></Breadcrumb>
      <a-card :bordered="false" :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}">
        <a-row slot="title">
          <a-col :span="8">
            <span class="card-title">基本信息</span>
          </a-col>
        </a-row>
        <a-form :form="form">
          <a-form-item label="内容类型" v-bind="formItemLayout">
            <a-radio-group v-decorator="['iconType']">
              <a-radio :value="0">商品类目（{{ iconProType | getAllProductTypeName }}）</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="图标" v-bind="formItemLayout" required>
            <a-upload
              name="file"
              :multiple="false"
              :action="uploadFileUrl"
              :fileList="fileList"
              @change="handleBusinessLicenseChange"
              :before-upload="handleBeforeUploadImage"
              v-decorator="[
            'uploadImage',
            {rules: [{ required: true, message: '请上传图片' }]}
          ]"
            >
              <a-button>
                <a-icon type="upload"/>
                上传文件
              </a-button>
              <span class="pl10">温馨提示：图片上传尺寸为 120*120 上传图片格式为.jpg、.png、.jpeg</span>
            </a-upload>

          </a-form-item>
          <a-form-item label="标题" v-bind="formItemLayout">
            <a-input placeholder="请输入" style="max-width:500px" :maxLength="99"
                     v-decorator="['iconName', { rules: [{ required: true, message: '请输入标题' }] }]"
            />
          </a-form-item>
          <a-form-item label="副标题" v-bind="formItemLayout">
            <a-input
              v-decorator="['iconSubTitle', {rules: [{ validator: checkIconSubTitle }], validateTrigger: 'change,blur'}]"
              placeholder="请输入"
              style="max-width:500px"
              :maxLength="99"
            />
          </a-form-item>
          <a-form-item label="开启频道" v-bind="formItemLayout" v-show="isShowControl">
            <a-radio-group v-decorator="['iconChannelControl']">
              <a-radio :value="1">开启</a-radio>
              <a-radio :value="0">关闭</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayoutBtn">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
            <a-button style="margin-left:10px;" v-if="productCategoryTemplateStatus==1" @click="resetImageIcon"
                      :loading="submitLoading">重置
            </a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixins from '../../../utils/mixins/formMixins'

export default {
  name: 'EditInletContent',
  mixins: [formMixins],
  components: {
    Breadcrumb
  },
  data() {
    return {
      iconProType: this.$route.query.iconProType,//商品类型
      iconId: this.$route.query.iconId,
      fileList: [],
      imageUrl: '',
      submitLoading: false,
      productCategoryTemplateId: 0,
      productCategoryTemplateStatus: 0,
      isShowControl: false
    }
  },
  mounted() {
    this.getHomeIconDetail()
  },
  methods: {
    checkIconSubTitle(rule, value, callback) {
      if (/[^\u4e00-\u9fa5a-zA-Z]/g.test(value)) {
        callback(new Error('请输入中英文'))
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag(res)
        let params = new Object()
        params.iconId = this.iconId
        params.iconProType = this.iconProType
        params.iconImg = this.imageUrl
        params.iconName = res.iconName
        params.iconType = res.iconType
        params.iconChannelControl = res.iconChannelControl
        params.iconSubTitle = res.iconSubTitle
        this.getLogUtils().logWithTag('保存表单数据', params)
        this.submitLoading = true
        this.getHttpServices().getUserService().post('homepage/icon/save/iconDetail', params)
          .then(res => {
            this.getLogUtils().logWithTag('==handleSubmit==', res)
            this.$message.success('内容保存成功')
            this.$router.push({
              name: 'HomeInlet'
            })
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      })
    },
    //上传图片
    handleBusinessLicenseChange(file) {
      this.getLogUtils().logWithTag('handleBusinessLicenseChange', file)
      if (file.file.status != 'removed') {
        this.fileList = [...file.fileList]
        this.fileList = this.fileList.slice(-1)
        this.fileList.forEach(file => {
          // 因为只有一个，所以可以用
          if (file.response) {
            this.imageUrl = file.response.data
          }
        })
      } else {
        this.fileList = []
        this.imageUrl = ''
        setTimeout(() => {
          this.form.setFieldsValue({
            uploadImage: undefined
          })
        }, 300)
      }
      this.getLogUtils().logWithTag('handleBusinessLicenseChange', this.fileList)
      this.getLogUtils().logWithTag('handleBusinessLicenseChange', this.imageUrl)
    },
    // 获取详情数据
    getHomeIconDetail() {
      this.getHttpServices().getUserService().post('homepage/icon/get/iconDetail', {
        iconId: this.iconId
      }).then(res => {
        this.getLogUtils().logWithTag('==getHomeIconDetail==', res)
        this.updateChannelControl(res.iconType)
        this.fileList = [
          {
            uid: '-1',
            name: res.iconImg,
            status: 'done',
            url: res.iconImg
          }
        ]
        this.imageUrl = res.iconImg
        this.productCategoryTemplateId = res.productCategoryTemplateId
        this.productCategoryTemplateStatus = res.productCategoryTemplateStatus
        this.$nextTick(() => {
          this.form.setFieldsValue({
            iconType: res.iconType,
            iconName: res.iconName,
            uploadImage: this.fileList,
            iconChannelControl: res.iconChannelControl,
            iconSubTitle: res.iconSubTitle
          })
        })
        this.getLogUtils().logWithTag('this.fileList', this.fileList)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateChannelControl(iconType) {
      if (iconType == 0 && (this.iconProType == 1 || this.iconProType == 2 || this.iconProType == 5)) {
        this.isShowControl = true
      } else {
        this.isShowControl = false
      }
    },
    resetImageIcon() {
      this.submitLoading = true
      let params = {
        iconId: this.iconId,
        productCategoryTemplateId: this.productCategoryTemplateId,
        productCategoryTemplateStatus: 2
      }
      this.getLogUtils().logWithTag('==resetImageIcon==params', params)
      this.getHttpServices().getUserService().post('homepage/icon/update/productCategoryTemplateStatus', params)
        .then(res => {
          this.getLogUtils().logWithTag('==resetImageIcon==', res)
          this.$message.success('图标重置成功')
          this.$router.push({
            name: 'HomeInlet'
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>